export default "__VITE_ASSET__ecRE0e4x__"